export default function BrandIntro() {
  return (
    <section className="mb-16" aria-labelledby="brand-heading">
      <h1 id="brand-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-6">
        关于文爱社区
      </h1>
      <div className="bg-background-100 rounded-lg p-6 md:p-8">
        <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-4">
          文爱社区创立于2020年，是一个专注于<strong>文字情感表达与互动</strong>的高品质社区平台。我们相信，
          文字是最温暖、最深刻的情感载体。在这个快节奏的数字时代，文爱社区致力于为热爱文字交流的用户
          提供一个静谧而充满温度的空间。
        </p>
        <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-4">
          无论你是想记录生活点滴、抒发内心情感，还是寻找志同道合的文字伴侣，文爱社区都欢迎你的到来。
          在这里，每一个字都承载着情感，每一句话都传递着温度。我们汇聚了来自全国各地的文字爱好者，
          共同构建一个<strong>温暖、安全、高质量</strong>的文字交流社区。
        </p>
        <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
          目前，文爱社区已拥有超过50万注册用户，累计产生100万+原创文章和500万+互动评论。
          我们持续优化平台体验，致力于让每一位用户都能在这里找到归属感和共鸣。
        </p>
      </div>
    </section>
  );
}